import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import * as colors from '../../../common/colorConstants';
import { NextButton } from '../../../common/buttonsComponents';
import { getRbiCustomerInfoByEmail } from '../../../../actions/tools/RBIActions';
import { addEdgeToDecisionTreePath } from '../../../../actions/searchActions';
import { clearToolsRbiStore } from '../../../../actions/creatorsSync';
import { getDecisionNodeAtPath } from '../../../../extractFromState';
import { maskCardNumber } from '../../../../util';
import { HeaderContainer, SpinnerWrapper, Spinner, SubTitle, Title } from '../../DecisionTree.styles';
import {
  SearchContainer,
  SearchField,
  SearchResultContainer,
  SearchResultHeader,
  SearchResultHead,
  SearchResultRow,
  SearchResultTitle,
  SearchResultValue,
  Button,
} from './DTRBISearchGiftCardNode.styles';

const DecisionTreeRbiSearchGiftCardContainer = () => {
  const [email, setEmail] = useState('');
  const dispatch = useDispatch();

  const decisionNode = useSelector((state) => getDecisionNodeAtPath(state));
  const customer = useSelector((state) => state.tools.decisionTree.rbi.customer);
  const isLoading = useSelector(
    (state) => state.ui.loading.isLoading && state.ui.loading.component === 'searchGiftCard'
  );

  useEffect(() => {
    dispatch(clearToolsRbiStore());
  }, [dispatch]);

  const handleSearch = () => {
    dispatch(clearToolsRbiStore());
    dispatch(getRbiCustomerInfoByEmail(email));
  };

  const handleContinueTransfer = () => {
    dispatch(addEdgeToDecisionTreePath('card_found'));
  };

  return (
    <>
      <HeaderContainer>
        {decisionNode?.title && <Title>{decisionNode.title}</Title>}
        {decisionNode?.subText && <SubTitle>{decisionNode.subText}</SubTitle>}
      </HeaderContainer>
      <SearchContainer>
        <SearchField placeholder="Enter user email" value={email} onChange={(e) => setEmail(e.target.value.trim())} />
        <NextButton id="searchGiftCard" active={true} onClick={handleSearch}>
          Search
        </NextButton>
      </SearchContainer>

      {isLoading && (
        <SpinnerWrapper>
          <Spinner color={colors.purple1} />
        </SpinnerWrapper>
      )}

      {!isEmpty(customer) && !isLoading && (
        <SearchResultContainer>
          <SearchResultHeader>Search results</SearchResultHeader>
          <SearchResultHead>Gift card associated to</SearchResultHead>
          <SearchResultRow>
            <SearchResultTitle>Card Number</SearchResultTitle>
            <SearchResultValue>{maskCardNumber(customer.cardNumber)}</SearchResultValue>
          </SearchResultRow>
          <SearchResultRow>
            <SearchResultTitle>User ID</SearchResultTitle>
            <SearchResultValue>{customer.customerId}</SearchResultValue>
          </SearchResultRow>
          <SearchResultRow>
            <SearchResultTitle>Name</SearchResultTitle>
            <SearchResultValue>{customer.name}</SearchResultValue>
          </SearchResultRow>
          <SearchResultRow>
            <SearchResultTitle>Email address</SearchResultTitle>
            <SearchResultValue>{customer.email}</SearchResultValue>
          </SearchResultRow>
          <SearchResultRow>
            <SearchResultTitle>Prepaid balance</SearchResultTitle>
            <SearchResultValue>${customer.currentBalance}</SearchResultValue>
          </SearchResultRow>
          <SearchResultRow>
            <SearchResultTitle>Prepaid Country</SearchResultTitle>
            <SearchResultValue>{customer.countryCode}</SearchResultValue>
          </SearchResultRow>
          <Button id="continueTransferring" active={true} onClick={handleContinueTransfer}>
            Continue Transferring
          </Button>
        </SearchResultContainer>
      )}
    </>
  );
};

export default DecisionTreeRbiSearchGiftCardContainer;
